import { ReactElement } from 'react'
import { Divider, useTheme } from '@mui/material'
import { ToggleButtonDropDown, ToggleDropDownOptions } from '@ui/actions'
import { Slab } from '@ui/icons'
import { structureDrawOptions, modelDrawOptions } from './constants'

interface Props {
  onClick: (value: StructuralPlanningModes) => void
  value?: StructuralPlanningModes
}

const EditElementSelect = ({ onClick, value }: Props): ReactElement => {
  const theme = useTheme()

  return (
    <ToggleButtonDropDown
      hint="Zeichnen"
      openAbove
      tooltipPlacement="top"
      toggleType="click"
      closeOnChildrenClick
      style={{
        color: theme.palette.grey[800],
        backgroundColor: value ? theme.palette.grey[400] : undefined,
        borderColor: theme.palette.grey[600],
      }}
      Icon={Slab}
      data-cy="btn-draw-select"
    >
      <ToggleDropDownOptions value={value} onClick={onClick} options={modelDrawOptions} />
      <Divider sx={{ my: 0.5 }} />
      <ToggleDropDownOptions value={value} onClick={onClick} options={structureDrawOptions} />
    </ToggleButtonDropDown>
  )
}

export default EditElementSelect
